module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10063.6bd3fed5.jpg";